import "../../styles/legal/privacy.css";

const HELP_EMAIL = import.meta.env.VITE_HELP_EMAIL;

const Privacy = () => {
  return (
    <section className="privacy-page">
      <h1>Privacy Policy</h1>

      <p className="updated">Last updated: January 2026</p>

      <div className="privacy-section">
        <h2>1. Introduction</h2>
        <p>
          VisualLab respects your privacy. This Privacy Policy explains how we
          collect, use, and protect your information when you use our platform.
        </p>
      </div>

      <div className="privacy-section">
        <h2>2. Information We Collect</h2>
        <ul>
          <li>First name and last name</li>
          <li>Email address</li>
          <li>Password (securely hashed)</li>
          <li>Profile information such as bio and avatar (optional)</li>
          <li>Visualizations, animations, and drafts you create</li>
        </ul>
      </div>

      <div className="privacy-section">
        <h2>3. Analytics & Usage Data</h2>
        <p>
          We collect anonymous analytics data such as page views, interaction
          counts, and time spent on pages. This data is used solely to
          understand usage patterns and improve the overall quality and
          performance of the platform.
        </p>
      </div>

      <div className="privacy-section">
        <h2>4. Cookies & Storage</h2>
        <ul>
          <li>Cookies are used for authentication and session management</li>
          <li>
            Browser storage is used to generate anonymous analytics visitor
            identifiers
          </li>
        </ul>
      </div>

      <div className="privacy-section">
        <h2>5. Data Security</h2>
        <p>
          We implement reasonable security practices to protect your data.
          Passwords are securely encrypted, and sensitive information is never
          shared publicly.
        </p>
      </div>

      <div className="privacy-section">
        <h2>6. Your Rights</h2>
        <p>
          You may update your profile information at any time through your
          account settings.
        </p>
        <p>
          Account deletion is not available directly through the platform in
          Phase 1. If you wish to delete your account, please contact us at{" "}
          <a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>.
        </p>
      </div>

      <div className="privacy-section">
        <h2>7. Feedback & Contact</h2>
        <p>
          If you have questions about this Privacy Policy or wish to provide
          feedback, you may use the in-app feedback option or contact us
          directly.
        </p>
      </div>
    </section>
  );
};

export default Privacy;
